import React from "react";
import HandleSpawn from "../Handle/HandleSpawn";

function Spawn() {
  return <HandleSpawn />;
}

export default Spawn;
